var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAlert(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    viewBox: "0 0 36 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_2592_56",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_2592_56)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9988 25.5C18.4238 25.5 18.7801 25.3562 19.0676 25.0687C19.3551 24.7812 19.4988 24.425 19.4988 24C19.4988 23.575 19.3551 23.2187 19.0676 22.9312C18.7801 22.6437 18.4238 22.5 17.9988 22.5C17.5738 22.5 17.2176 22.6437 16.9301 22.9312C16.6426 23.2187 16.4988 23.575 16.4988 24C16.4988 24.425 16.6426 24.7812 16.9301 25.0687C17.2176 25.3562 17.5738 25.5 17.9988 25.5ZM16.4988 19.5H19.4988V10.5H16.4988V19.5ZM17.9988 34.95L12.9738 30H5.99883V23.025L1.04883 18L5.99883 12.975V5.99999H12.9738L17.9988 1.04999L23.0238 5.99999H29.9988V12.975L34.9488 18L29.9988 23.025V30H23.0238L17.9988 34.95ZM17.9988 30.75L21.7488 27H26.9988V21.75L30.7488 18L26.9988 14.25V8.99999H21.7488L17.9988 5.24999L14.2488 8.99999H8.99883V14.25L5.24883 18L8.99883 21.75V27H14.2488L17.9988 30.75Z",
    fill: "#FC9700"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAlert);
export default __webpack_public_path__ + "static/media/alert.d1eda71d40ab848f77fdeefe5c135eba.svg";
export { ForwardRef as ReactComponent };